<sh-form-group
  [invalid]="isControlInvalid$ | async"
  [required]="false"
  [label]="label"
  [labelIcons]="labelIcons"
  [helpText]="helpText"
  [describeLabelId]="describeLabelId"
  [errorMsg]="errorMsg"
  [id]="id"
  >
  <ng-content></ng-content>

  @if (canBeIndeterminate) {
    <med-form-permissions-complex-base
      [indeterminateMsg]="indeterminateMsg"
      [required]="(isControlRequired$ | async) && !isBatchEdit"
      [isDisabled]="control.disabled"
      [formControl]="control"
      [readLabel]="readLabel"
      [writeLabel]="writeLabel"
      [exportLabel]="exportLabel"
      [noneSelectedMsg]="noneSelectedMsg"
      [multipleSelectedMsg]="multipleSelectedMsg"
      [allSelectedMsg]="allSelectedMsg"
      [openDirection]="openDirection"
      [errorMsg]="errorMsg"
      [id]="id"
      [isBatchEdit]="isBatchEdit"
    ></med-form-permissions-complex-base>
  } @else {
    <med-form-permissions-base
      [required]="(isControlRequired$ | async) && !isBatchEdit"
      [isDisabled]="control.disabled"
      [formControl]="control"
      [readLabel]="readLabel"
      [writeLabel]="writeLabel"
      [exportLabel]="exportLabel"
      [noneSelectedMsg]="noneSelectedMsg"
      [multipleSelectedMsg]="multipleSelectedMsg"
      [allSelectedMsg]="allSelectedMsg"
      [openDirection]="openDirection"
      [errorMsg]="errorMsg"
      [id]="id"
      [isBatchEdit]="isBatchEdit"
    ></med-form-permissions-base>
  }

</sh-form-group>
